module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-01.74861a4f.png";